// @ts-check

import Act from "../../../../../store/actions";

/**
 *
 * @param data {import('../../../SnaPage').ApiSnaData[]}
 * @param eventTypes  {import('../../../SnaPage').EventType}
 * @returns {*[]}
 */
export const filterNetworkDataByEventType = (data, eventTypes) => {
  if (!Array.isArray(data)) return [];
  const tmpData = [...data];
  if (!Array.isArray(eventTypes)) return tmpData;
  const eventTypesIdChecked = eventTypes
    .filter((o) => o.checked)
    .map((o) => o.id);
  return tmpData.filter((o) => eventTypesIdChecked.includes(o.eventType));
};

/**
 * 檢查所有的資料集是否為空
 * @param _dataset {{public:*[],personal:*[]}}
 * @returns {*}
 */
export const isAllDatasetNotNull = (_dataset) =>
  ["public", "personal"].reduce((acc, cur) => {
    // @ts-ignore
    if (!(cur in _dataset && Array.isArray(_dataset[cur]))) return false;
    return acc;
  }, true);

/**
 *
 * @param focusNodes {object[]}
 * @param setFocusNodes {function}
 * @returns {(function(string, object): void)|*}
 */
export const onClickNode =
  // @ts-ignore
  (focusNodes, setFocusNodes) => (nodeId, nodeState) => {
    const { isFocus, d, selection } = nodeState;
    // 不可使用 focusNodes(因為狀態沒有更新,會一直抓到舊的 state)
    // 但可以使用 setFocusNodes((prev)=>....) 的方式
    // 更新 focusNodes
    // isFocus
    if (isFocus) {
      // @ts-ignore
      setFocusNodes((prev) =>
        prev
          // @ts-ignore
          .filter((o) => o.id !== nodeId)
          .concat([
            {
              id: nodeId,
            },
          ])
      );
    } else {
      // @ts-ignore
      setFocusNodes((prev) => prev.filter((o) => o.id !== nodeId));
    }
  };

// @ts-ignore
export const onMouseOverNode = (state, dispatch) => () => {};

// @ts-ignore
export const onMouseOutNode = (state, dispatch) => () => {};

// @ts-ignore
export const onClickLink = (state, dispatch) => () => {};
